<script>
import inViewport from 'vue-in-viewport-mixin'

const config = {
  // In ms
  INTERVAL: 5000,

  // Tabs count
  COUNT: 7
}

export default {
  name: 'HomeFeaturesCarousle',
  mixins: [ inViewport ],

  data () {
    return {
      activeIndex: 0,
      paused: true,
      showNextTimer: null
    }
  },

  watch: {
    'inViewport.now' (isTrue) {
      if (isTrue) {
        this.paused = false
        this.resetTimer()
      } else {
        this.paused = true
        clearTimeout(this.showNextTimer)
      }
    }
  },

  methods: {
    setActive (index) {
      this.activeIndex = index || 0
      this.resetTimer()
    },

    isActive (index) {
      return this.activeIndex === index
    },

    toPrevious () {
      this.activeIndex = ((this.activeIndex - 1) + config.COUNT) % config.COUNT
      this.resetTimer()
    },

    toNext () {
      this.activeIndex = (this.activeIndex + 1) % config.COUNT
      this.resetTimer()
    },

    showNext () {
      if (this.paused) { return }
      this.toNext()
    },

    resetTimer () {
      clearTimeout(this.showNextTimer)
      this.showNextTimer = setTimeout(() => {
        clearTimeout(this.showNextTimer)
        this.showNext()
      }, config.INTERVAL)
    }
  },

  mounted () {
    this.resetTimer()
    if (this.inViewport.now) {
      this.paused = false
    }
  },

  beforeDestroy () {
    clearTimeout(this.showNextTimer)
  }
}
</script>

<template lang="pug">
section.edu-features-carousel
  .tabs
    .tab-item(:class="{'active': isActive(0)}" @click="setActive(0)")
      .item-title 全明星团队
      .item-text Expertise
    .tab-item(:class="{'active': isActive(1)}" @click="setActive(1)")
      .item-title 全方位评估
      .item-text Dimension
    .tab-item(:class="{'active': isActive(2)}" @click="setActive(2)")
      .item-title 全感官交互
      .item-text Usability
    .tab-item(:class="{'active': isActive(3)}" @click="setActive(3)")
      .item-title 全场景覆盖
      .item-text Construct
    .tab-item(:class="{'active': isActive(4)}" @click="setActive(4)")
      .item-title 全自动分析
      .item-text Analysis
    .tab-item(:class="{'active': isActive(5)}" @click="setActive(5)")
      .item-title 全过程跟踪
      .item-text Trail
    .tab-item(:class="{'active': isActive(6)}" @click="setActive(6)")
      .item-title 全智能体验
      .item-text Efficiency
  .body
    .button-wrapper.btn-left(@click="toPrevious(true)")
      .dmico-icon-caret-left

    .body-main
      transition(name="fade" appear mode="out-in")
        //- 0: 全明星团队
        .body-item(v-if="isActive(0)")
          .item-content.expertise
            .card
              .expert-pic.molei
              .expert-name 莫雷
              ul.expert-intro
                li 华南师范大学副校长，教授，博士生导师
                li 省重点学科教育心理学的学术带头人
                li 国家教委心理学教学指导委员会委员
                li 中国心理学会教育心理专业委员会副主任
                li 广东心理学会教育心理专业委员会主任
                li 中科院心理研究所开放实验室学术委员
                li 第十届中国心理学会理事长
                li 中国心理学会终身成就奖
                li 第六届国务院学位委员会学科评议组召集人
                li 享受国务院政府一级特殊津贴
            .card
              .expert-pic.chenfeng
              .expert-name 陈峰
              ul.expert-intro
                li 广州市华美英语实验学校总校长
                li 中国教育学会教育实验分会副理事长
                li 中国教育技术协会中小学外语教学信息化工作委员会副主任
                li 广东省民办教育协会常务副会长兼中小学理事会理事长
                li 广东省中小学校长联合会副会长
            .card
              .expert-pic.wenhongbo
              .expert-name 温红博
              ul.expert-intro
                li 国家教育部基础教育质量监测中心主任助理
                li 北京师范大学教育统计与测量研究所副教授
                li 华南师范大学心理学博士

      transition(name="fade" appear mode="out-in")
        //- 1: 全方位评估
        .body-item(v-if="isActive(1)")
          .item-content.dimension
            .card
              .dms-icon.dmico-icon-dms-career
              .dms-title 生涯规划
              .dms-text 指导学生正确认识不同职业的素质能力需求、未来发展前景、社会价值与责任等，结合自己的职业兴趣、特长、个性等因素，合理设定升学与就业目标，优化从学涯到职涯的路线规划，树立自我生涯发展与规划的意识。
            .card
              .dms-icon.dmico-icon-dms-health
              .dms-title 心理健康
              .dms-text 指导学生正确认识自我，增强调控情绪、应对压力、承受挫折的能力，及时识别学生的心理困扰或心理问题，保障和提高学生的心理健康水平。
            .card
              .dms-icon.dmico-icon-dms-character
              .dms-title 品德个性
              .dms-text 指导学生客观了解自己的个性特征、素质特长、优点缺点，形成正确理想信念、良好道德品质、积极健全人格。提高学生管理时间、适应环境、人际相处的能力。
            .card
              .dms-icon.dmico-icon-dms-diagnosis
              .dms-title 学情诊断
              .dms-text 指导学生了解学业特点和选科要求，结合自己学力情况，科学设定学习目标、改善学习方法、合理制定学习计划。提高学生自主选课能力，发挥学科特长，提升学习效能和产出。
            .card
              .dms-icon.dmico-icon-dms-family
              .dms-title 家庭环境
              .dms-text 引导学生正确看待家庭环境与生命价值，促进学生形成良好行为习惯、健康生活方式。指导家长客观了解其养育模式和教养质量，提高父母胜任力，识别家庭系统中可能存在的问题。

      transition(name="fade" appear mode="out-in")
        //- 2: 全感官交互
        .body-item(v-if="isActive(2)")
          .item-content.usability
            .feature-sample.usability-sample(alt="全感官交互 Usability")

      transition(name="fade" appear mode="out-in")
        //- 3: 全场景覆盖
        .body-item(v-if="isActive(3)")
          .item-content.construct
            .feature-sample.construct-sample(alt="全场景覆盖 Construct")

      transition(name="fade" appear mode="out-in")
        //- 4: 全自动分析
        .body-item(v-if="isActive(4)")
          .item-content.analysis
            .content-inner
              .item-block
                .icon-bg
                  .dmico-icon-analysis-data
                .item-title 数据
              .item-block
                .icon-bg
                  .dmico-icon-analysis-collect
                .item-title 采集
                .item-text 实时分析回答情况，并根据预先设定的递进条件、自动匹配不同深度的后续题目，让数据采集一步到位。
              .item-block
                .icon-bg
                  .dmico-icon-analysis-analysis
                .item-title 分析
                .item-text 一键获取分析结果：无效数据标识、描述性统计、交叉表、相关分析……让数据分析前所未有的简单。
              .item-block
                .icon-bg
                  .dmico-icon-analysis-modeling
                .item-title 建模
                .item-text 借助成熟的数据建模方法，整合不同来源的评估结果，深挖数据间关系，科学完整地描绘学生心理面貌。
              .item-block
                .icon-bg
                  .dmico-icon-analysis-present
                .item-title 呈现
                .item-text 根据数据分析建模的结果，自动生成精美的可视化图表，以看板方式优雅呈现。图表均可下载和打印。

      transition(name="fade" appear mode="out-in")
        //- 5: 全过程跟踪
        .body-item(v-if="isActive(5)")
          .item-content.construct
            .feature-sample.trail-sample(alt="全过程跟踪 Trail")

      transition(name="fade" appear mode="out-in")
        //- 6: 全智能体验
        .body-item(v-if="isActive(6)")
          .item-content.efficiency
            .feature-sample.efficiency-sample(alt="全智能体验 Efficiency")

    .button-wrapper.btn-right(@click="toNext(true)")
      .dmico-icon-caret-right
</template>

<style lang="scss">
@import "../../styles/variables";

section.edu-features-carousel {
  .tabs {
    height: 88px;
    margin: 0 60px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: stretch;

    .tab-item {
      flex: 1 1 0.000001px;
      padding: 20px 0;
      text-align: center;
      cursor: pointer;
      transition: background .3s, border-color .3s;
      border-bottom: 8px solid transparentize($primary-color, 1);

      .item-title,
      .item-text {
        transition: color .3s;
      }

      .item-title {
        color: $text-dark;
        font-weight: 600;
        margin-bottom: 0.5em;
        transition: color .3s;
      }

      .item-text {
        color: $text-light-gray;
        font-size: 14px;
        transition: color .3s;
      }

      &:hover {
        background: transparentize($bg-lighter-gray, 0.5);
        border-bottom-color: transparentize($primary-color, 0.6);
      }

      &.active {
        background: $bg-lighter-gray;
        border-bottom-color: $primary-color;

        .item-title {
          color: $primary-color;
        }

        .item-text {
          color: $text-dark-gray;
        }
      }
    }
  }

  .body {
    height: 680px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;

    .button-wrapper {
      @include square(60px);
      border-radius: 60px;
      background: $bg-light-gray;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: opacity .3s;

      &:hover {
        opacity: 0.8;
      }

      &:active {
        opacity: 0.6;
      }
    }

    .body-main {
      flex: 1 1 0.00001px;
      align-self: stretch;
      position: relative;
    }

    .body-item {
      @include absFullSpread;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      // opacity: 0;
      // transition: opacity .5s;

      // &.visible {
      //   opacity: 1;
      // }
    }

    .item-content {
      @include absFullSpread;

      &.expertise {
        margin: 30px 10px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: stretch;

        .card {
          flex: 1 1 0.00001px;
          margin: 0 12px;
          padding: 40px 30px;
          border-radius: 20px;
          box-shadow: 0 7px 45px black(0.1);

          display: flex;
          flex-flow: column nowrap;
          justify-content: flex-start;
          align-items: center;
        }

        .expert-pic {
          @include bgImage;
          @include square(122px);

          &.molei {
            background-image: url(../../assets/images/edu-expert-molei.png);
          }
          &.chenfeng {
            background-image: url(../../assets/images/edu-expert-chenfeng.png);
          }
          &.wenhongbo {
            background-image: url(../../assets/images/edu-expert-wenhongbo.png);
          }
        }

        .expert-name {
          color: $secondary-blue;
          font-size: 22px;
          font-weight: 600;
          margin: 30px 0;
        }

        ul.expert-intro {
          margin: 0;
          padding: 0 0 0 1.4em;
          list-style: none;
          font-size: 13px;

          li {
            line-height: 150%;
            padding-top: 10px;

            &:before {
              content: "\2022";
              color: $secondary-blue;
              font-weight: bold;
              display: inline-block;
              width: 1em;
              margin-left: -1.4em; 
              margin-right: 0.4em;
            }
            
            &:first-of-type {
              padding-top: 0;
            }
          }
        }
      }

      &.dimension {
        margin: 30px 10px;
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        align-items: center;
        align-content: center;

        .card {
          width: 30%;
          height: 295px;
          box-sizing: padding-box;
          margin: 15px;
          padding: 30px;
          border-radius: 20px;
          box-shadow: 0 7px 45px black(0.1);

          display: flex;
          flex-flow: column nowrap;
          justify-content: flex-start;
          align-items: center;
        }

        .dms-title {
          margin: 10px 0;
          font-size: 20px;
          font-weight: 900;
          letter-spacing: 3px;
        }

        .dms-text {
          color: $text-gray;
          line-height: 150%;
          font-size: 14px;
        }
      }

      &.analysis {
        margin: 30px 80px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;

        .content-inner {
          flex: 1 1 0.00001px;
          display: flex;
          flex-flow: row nowrap;
          justify-content: space-between;
          align-items: stretch;

          .item-block {
            width: 18%;
            display: flex;
            flex-flow: column nowrap;
            justify-content: flex-start;
            align-items: center;
            position: relative;

            &:before {
              content: '';
              position: absolute;
              width: 50%;
              height: 2px;
              background: #A4AABC;
              left: 0;
              top: 26px;
              transform: translateX(-65%);
            }

            &:first-of-type {
              &::before {
                display: none;
              }
            }

            .icon-bg {
              @include square(56px);
              border-radius: 50%;
              display: flex;
              flex-flow: row nowrap;
              justify-content: center;
              align-items: center;
              background: #fff;
              box-shadow: 0 7px 45px black(0.1);
            }

            .item-title {
              color: $secondary-blue;
              font-size: 16px;
              font-weight: 600;
              margin: 20px 0;
            }

            .item-text {
              padding: 20px;
              border-radius: 20px;
              background: $bg-light-gray;
              text-align: justify;
              font-size: 14px;
              line-height: 150%;;
            }
          }
        }
      }

      &.usability,
      &.construct,
      &.trail,
      &.efficiency {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;

        .feature-sample {
          @include bgImage;
          max-width: 100%;

          &.usability-sample {
            width: 780px;
            height: 584px;
            background-image: url(../../assets/images/edu-features-usability.png);
          }

          &.construct-sample {
            width: 984px;
            height: 620px;
            background-image: url(../../assets/images/edu-features-construct.png);
          }

          &.trail-sample {
            width: 1020px;
            height: 620px;
            background-image: url(../../assets/images/edu-features-trail.png);
          }

          &.efficiency-sample {
            width: 880px;
            height: 504px;
            background-image: url(../../assets/images/edu-features-efficiency.png);
          }
        }
      }
    }
  }
}
</style>